<template>
  <div class="main-cn">
    <div class="main-bd mg20">
      <div class="main-bd mg20 pro-visible">
        <el-form ref="form" :inline="true" :model="searcheModel">
          <el-form-item label="所属部门">
            <UserCascader
              v-model="searcheModel.branch_id"
              ref="branch"
              :isBusiness="true"
              :multiple="true"
              @change="changeBranch"
            ></UserCascader>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker
              size="small"
              v-model="searcheModel.order_created_at"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="text" size="mini" @click="setCreateAt('to_day')"
              >今日</el-button
            >
            <el-button type="text" size="mini" @click="setCreateAt('this_week')"
              >本周</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="setCreateAt('this_month')"
              >本月</el-button
            >
          </el-form-item>
          <el-form-item label="屏蔽排课升级单">
              <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
              <el-option label="不限" value=""></el-option>
              <el-option label="是" value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="财务审核">
              <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                  <el-option label="不限" value=""></el-option>
                  <el-option label="通过" value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="submitSearch"
              >搜索</el-button
            >
            <el-button @click="resetForm()" size="small">重置</el-button>
            <ExportFile 
              v-if="Acs('/export/collect')"
              :url="'/api/export/collect'" 
              :params="searcheModel" 
              filename="数据总览" 
              buttonName="导出Excel">
            </ExportFile>
          </el-form-item>
        </el-form>
      </div>

      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/ranking-user') || Acs('/order-count/briefing')">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="6" v-if="Acs('/order-count/ranking-user') || Acs('/order-count/ranking-group') || Acs('/order-count/ranking-branch')" v-loading="ranking_loading">
            <el-card>
              <el-row :gutter="10" class="searchSection">
                <el-col :span="10">
                  <div>
                    <label class="item-title">销售排行榜</label>
                  </div>
                  <div>
                    <label class="item-desc">按录单时间统计</label>
                  </div>
                </el-col>
                <el-col :span="14">
                  <label class="item-title">统计类型：</label>
                  <el-select
                    v-model="searcheModel.type"
                    size="mini"
                    style="width: 100px"
                    @change="handleRankingChange"
                  >
                    <el-option label="业绩目标" value="1"></el-option>
                    <el-option label="续费目标" value="2"></el-option>
                    <el-option label="回款目标" value="3"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-tabs
                v-model="searcheModel.level"
                type="card"
                @tab-click="handleRankingChange"
              >
                <el-tab-pane label="业务员" name="0" v-if="Acs('/order-count/ranking-user')"></el-tab-pane>
                <el-tab-pane label="小组" name="3" v-if="Acs('/order-count/ranking-group')"></el-tab-pane>
                <el-tab-pane label="部门" name="2" v-if="Acs('/order-count/ranking-branch')"></el-tab-pane>
              </el-tabs>
              <div style="height: 435px; overflow-y: auto">
                <el-table :data="ranking_list">
                  <el-table-column label="排名" width="50">
                    <template slot-scope="scope">
                      <span v-if="scope.$index == 0"
                        ><i class="el-icon-medal gold-medal"></i
                      ></span>
                      <span v-else-if="scope.$index == 1"
                        ><i class="el-icon-medal silver-medal"></i
                      ></span>
                      <span v-else-if="scope.$index == 2"
                        ><i class="el-icon-medal bronze-medal"></i
                      ></span>
                      <span v-else>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" :label="searcheModel.level == 0 ? '业务员' : searcheModel.level == 3 ? '小组' : '部门'"></el-table-column>
                  <el-table-column v-if="searcheModel.type == 1" prop="total_pfm_amount" label="完成业绩"></el-table-column>
                  <el-table-column v-if="searcheModel.type == 2" prop="total_finish_amount" label="完成续费"></el-table-column>
                  <el-table-column v-if="searcheModel.type == 3" prop="total_actual_amount" label="完成回款"></el-table-column>
                </el-table>
              </div>
            </el-card>
            
          </el-col>
          <el-col :span="18" v-if="Acs('/order-count/briefing')" v-loading="briefing_loading">
            <el-card>
              <div>
                  <label class="item-title">数据简报</label>
                  <el-tooltip placement="top" effect="dark">
                      <div slot="content">
                          平均客单价：=销售额/去重客户数  （销售额和去重客户数均已过滤掉销售额为 0 的订单）<br/>
                          新签约客户数：=客户创建后首次录入正式新单的客户数量<br/>
                          转介绍客户数：=成交订单来源为“客户转介绍”的客户数量（去重）<br/>
                          客户复购数：合作过A产品又再次合作B产品的客户数<br/>
                          平均成交周期：=申请时间内 所有（关联客户首次创建新单时间-线索绑定时间）之和转换的天数/成交客户数
                      </div>
                      <i class="el-icon-info"></i>
                  </el-tooltip>
              </div>
              <el-row :gutter="10" class="data-briefing">
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">新增业绩</p>
                    <p class="grid-count-money">¥ {{ briefing_data.total_pfm_amount }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按录单时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">续费完成</p>
                    <p class="grid-count-money">¥ {{ briefing_data.total_finish_amount }}</p>
                    <p class="grid-subtext">续费业绩：¥ {{ briefing_data.total_renew_amount }}</p>
                    <p class="description">按录单时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">回款金额</p>
                    <p class="grid-count-money">¥ {{ briefing_data.total_payment_amount }}</p>
                    <p class="grid-subtext">
                      新增：¥
                      {{ briefing_data.total_payment_formal_amount }} &nbsp;&nbsp;
                      续费：¥ {{ briefing_data.total_payment_renew_amount }}
                    </p>
                    <p class="description">按实际回款时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">销售额</p>
                    <p class="grid-count-money">¥ {{ briefing_data.all_total_amount }}</p>
                    <p class="grid-subtext">
                      平均客单价：¥
                      {{ briefing_data.average_order_value }}
                    </p>
                    <p class="description">按录单时间统计</p>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="10" class="data-briefing">
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">跟进线索数</p>
                    <p class="grid-count-num">{{ briefing_data.trace_sales_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按跟进时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">跟进客户数</p>
                    <p class="grid-count-num">{{ briefing_data.trace_customer_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按跟进时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">试用订单数</p>
                    <p class="grid-count-num">{{ briefing_data.try_out_order_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按录单时间统计</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">正式订单数</p>
                    <p class="grid-count-num">
                      {{
                        briefing_data.formal_order_num
                      }}
                    </p>
                    <p class="grid-subtext">
                      新单：{{ briefing_data.pfm_order_num }} &nbsp;&nbsp; 续费：{{
                        briefing_data.renew_order_num
                      }}
                    </p>
                    <p class="description">按录单时间统计</p>
                  </div>
                </el-col>
              </el-row>
               <el-row :gutter="10" class="data-briefing">
                 <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">新签约客户数</p>
                    <p class="grid-count-num">{{ briefing_data.new_signed_customer_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按录单时间</p>
                  </div>
                </el-col>
                 <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">转介绍客户数</p>
                    <p class="grid-count-num">{{ briefing_data.referred_customer_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按录单时间</p>
                  </div>
                </el-col>
                 <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">客户复购数</p>
                    <p class="grid-count-num">{{ briefing_data.customer_purchases_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按录单时间,按负责人</p>
                  </div>
                </el-col>
                <!--2025年12月，上线后市场部不需要，就屏蔽了
                 <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">客户复购率</p>
                    <p class="grid-count-num">{{ briefing_data.customer_purchases_num }}</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按客户创建时间</p>
                  </div>
                </el-col>
                 <el-col :span="6">
                  <div class="grid-content">
                    <p class="grid-p">平均成交周期</p>
                    <p class="grid-count-num">{{ briefing_data.average_transaction_cycle }}天</p>
                    <p class="grid-subtext">&nbsp;</p>
                    <p class="description">按申请时间统计</p>
                  </div>
                </el-col>-->
              </el-row>
            </el-card>
            
          </el-col>
        </el-row>
      </div>

      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/traces')" v-loading="traces_loading">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="10">
            <div>
              <label class="item-title">业务员跟进情况</label>
            </div>
            <div>
              <label class="item-desc">按跟进时间统计</label>
            </div>
          </el-col>
        </el-row>
        <el-table v-if="!traces_loading"
        :data="traces_list" 
        border 
        height="400"
        row-key="id" 
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
        :header-cell-style="{background: '#f3faff'}"
        :summary-method="getSummaries" 
        show-summary>
          <el-table-column prop="user_name" label="业务员"></el-table-column>
          <el-table-column prop="entry_at" label="入职时间"></el-table-column>
          <el-table-column prop="sales_num" label="跟进线索数量" sortable></el-table-column>
          <el-table-column prop="sales_trace_num" label="线索跟进次数" sortable></el-table-column>
          <el-table-column prop="customer_num" label="跟进客户数量" sortable></el-table-column>
          <el-table-column prop="customer_trace_num" label="客户跟进次数" sortable></el-table-column>
          <el-table-column prop="try_out_customer_num" label="试用客户数" sortable></el-table-column>
          <el-table-column prop="deal_customer_num" label="成交客户数" sortable></el-table-column>
          <el-table-column prop="total_amount" label="销售额" sortable></el-table-column>
          <!-- <el-table-column prop="deep_trial_customer_num" label="有效试用客户数"></el-table-column> -->
        </el-table>
      </div>

      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/area-map') || !Acs('/order-count/area-list')">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="12" v-if="Acs('/order-count/area-map')">
            <el-card>
              <el-row :gutter="10" class="searchSection">
                <el-col :span="10">
                  <div>
                    <label class="item-title">成交客户地区分布</label>
                  </div>
                  <div>
                    <label class="item-desc">按录单时间统计</label>
                  </div>
                </el-col>
                <el-col :span="14">
                  <label class="item-title">地理地区：</label>
                  <el-select
                    v-model="searcheModel.area_type"
                    size="mini"
                    style="width: 100px"
                    @change="handleAreaClick"
                  >
                    <el-option label="不限" value="0"></el-option>
                    <el-option label="华北" value="1"></el-option>
                    <el-option label="华东" value="2"></el-option>
                    <el-option label="华南" value="3"></el-option>
                    <el-option label="华中" value="4"></el-option>
                    <el-option label="西南" value="5"></el-option>
                    <el-option label="西北" value="6"></el-option>
                    <el-option label="东北" value="7"></el-option>
                    <el-option label="港澳台" value="8"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <div>
                  <ChinaChart :params="searcheModel" :key="area_map_key" @change="chinaMapChange"></ChinaChart>
              </div>
            </el-card>
            
          </el-col>
          <el-col :span="12" v-if="Acs('/order-count/area-list')">
            <el-card>
              <el-tabs
                v-model="searcheModel.count_type"
                type="card"
                @tab-click="handleAreaClick"
              >
                <el-tab-pane label="按地区" name="1"></el-tab-pane>
                <el-tab-pane label="按部门" name="2"></el-tab-pane>
              </el-tabs>
              <AreaList :params="searcheModel" :key="area_table_key"></AreaList>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/customer-product')">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="4">
            <div>
              <label class="item-title">客户产品分布</label>
            </div>
            <div>
              <label class="item-desc">按录单时间统计</label>
            </div>
          </el-col>
          <el-col :span="5">
            <label class="item-title">统计类型：</label>
            <el-select
              v-model="searcheModel.count_type"
              size="mini"
              style="width: 100px"
              @change="handleProductClick"
            >
              <el-option label="按产品" value="1"></el-option>
              <el-option label="按部门" value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <label class="item-title">订单类型：</label>
            <el-select
              v-model="searcheModel.order_type"
              size="mini"
              style="width: 100px"
              @change="handleProductClick"
            >
              <el-option label="正式" value="4"></el-option>
              <el-option label="正式(新单)" value="2"></el-option>
              <el-option label="正式(续单)" value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>

        <div>
          <ProductChart :params="searcheModel" :key="product_map_key" @change="handleProductClick"></ProductChart>
        </div>
      </div>

      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/customer-level') || Acs('/order-count/customer-sale') || Acs('/order-count/customer-ratio')">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="6" v-if="Acs('/order-count/customer-level')">
            <el-card>
              <el-row :gutter="10" class="searchSection">
                <el-col :span="10">
                  <div>
                    <label class="item-title">客户级别分析</label>
                    <el-tooltip placement="right">
                      <div slot="content">
                        A:意向极高的客户<br />
                        B:试用中客户，到期自动掉至C级<br />
                        C:试用结束客户与其他客户<br />
                        D:正式客户，全部产品到期自动掉至E级<br />
                        E:断续客户<br />
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <div>
                    <label class="item-desc">按客户创建时间</label>
                  </div>
                </el-col>
              </el-row>
              <div>
                <CustomerLevelChart :params="searcheModel" :key="customer_level_map_key"></CustomerLevelChart>
              </div>
            </el-card>
          </el-col>
          <el-col :span="7" v-if="Acs('/order-count/customer-sale')">
            <el-card>
              <el-row :gutter="10" class="searchSection">
                <el-col :span="10">
                  <div>
                    <label class="item-title">销售漏斗</label>
                  </div>
                  <div>
                    <label class="item-desc">按客户创建时间</label>
                  </div>
                </el-col>
              </el-row>
              <div>
                <CustomerSaleChart :params="searcheModel" :key="customer_level_map_key"></CustomerSaleChart>
              </div>
            </el-card>
          </el-col>
          <el-col :span="11" v-if="Acs('/order-count/customer-ratio')">
            <el-card>
              <CustomerRatioProgress :params="searcheModel" :key="customer_ratio_table_key" @change="ratioProgressChange"></CustomerRatioProgress>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="main-bd mg20 pro-visible" v-if="Acs('/order-count/goal-finish')">
        <el-row :gutter="10" class="searchSection">
          <el-col :span="6">
            <div>
              <label class="item-title">业绩目标完成情况</label>
            </div>
            <div>
              <label class="item-desc">按录单时间统计</label>
            </div>
          </el-col>
          <el-col :span="6">
            <label class="item-title">统计类型：</label>
            <el-select v-model="searcheModel.type" size="small" style="width: 110px;" @change="handleRankingChange">
              <el-option label="业绩目标" value="1"></el-option>
              <el-option label="续费目标" value="2"></el-option>
              <el-option label="回款目标" value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <div style="height: 280px; overflow-y: auto">
          <GoalProgress :params="searcheModel" :key="goal_table_key"></GoalProgress>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* .pro-visible {
  background: #eeeeee;
} */
.grid-content {
  position: relative;
  width: 100%; /* 适应实际宽度 */
  height: 100%; /* 适应实际高度 */
  border-radius: 5px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
  background-color: #f2faff;
  opacity: 0.94;
  font-size: 14px;
  border: 2px solid #aeb6bf;
  font-weight: bolder;
}
.el-divider--horizontal {
  margin: 0 0;
}
.el-divider {
  background-color: #02a7f0;
}
.item-title {
  font-size: 14px;
  font-weight: bolder;
}
.item-desc {
  font-size: 10px;
  color: #aaaaaa;
}
.gold-medal {
  color: gold; /* 金色 */
  font-size: 24px;
}

.silver-medal {
  color: silver; /* 银色 */
  font-size: 24px;
}

.bronze-medal {
  color: #cd7f32; /* 铜色 */
  font-size: 24px;
}
.description {
  width: 100%;
  text-align: center;
  font-size: 10px;
  color: #aaaaaa;
  font-weight: normal;
}
.data-briefing {
  padding: 10px 0;
}
.grid-p {
  margin-bottom: 6px;
  height: 22px;
  line-height: 22px;
}
.grid-count-money {
  font-size: 16px;
  color: red;
  height: 28px;
  line-height: 28px;
}
.grid-count-num {
  font-size: 16px;
  color: #409EFF;
  height: 28px;
  line-height: 28px;
}
.grid-subtext {
  min-height: 22px;
  line-height: 22px;
  text-align: center;
  width: 100%;
}
</style>
<script>
import OrderCount from "~/services/OrderCount";
import UserCascader from "~/widgets/UserCascader.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import ChinaChart from "~/views/count/echarts/chinaChart.vue";
import AreaList from "~/views/count/table/area.vue";
import GoalProgress from "~/views/count/table/goalProgress.vue";
import ProductChart from "~/views/count/echarts/productChart.vue";
import CustomerLevelChart from "~/views/count/echarts/customerLevelChart.vue";
import CustomerSaleChart from "~/views/count/echarts/customerSaleChart.vue";
import CustomerRatioProgress from "~/views/count/table/customerRatioProgress.vue";
import Config from "~/config/params";
import echarts from "echarts";
import macarons from "~/assets/echart-map-themes/macarons";
import China from "echarts/map/js/china";
echarts.registerTheme("macarons", macarons);

export default {
  name: "collect",

  components: {
    UserCascader,
    ExportFile,
    Config,
    ChinaChart,
    AreaList,
    GoalProgress,
    ProductChart,
    CustomerLevelChart,
    CustomerSaleChart,
    CustomerRatioProgress
  },

  props: {},

  data() {
    return {
      searcheModel: {
        branch_id: "",
        order_created_at: Config.getDataTimes('this_week'),
        area_type: "",
        count_type: "1",
        province_id: '',
        type: "1", 
        level: "0",
        order_type: '4',
        down_num: '50',
        subject_num: '2',
        not_have_amount: '',
        finance_audit: ''
      },

      ranking_list: [],
      ranking_loading: false,

      briefing_data: [],
      briefing_loading: false,

      traces_list: [],
      traces_loading: false,

      area_map_key: 0,
      area_table_key: 0,

      product_map_key: 0,

      customer_level_map_key: 0,

      goal_table_key: 0,

      customer_ratio_table_key: 0,
    };
  },

  mounted() {},

  created: function () {
    this.submitSearch();
  },

  methods: {
    //重置按钮
    resetForm() {
      this.searcheModel = {
        branch_id: "",
        order_created_at: Config.getDataTimes('this_week'),
        area_type: "",
        count_type: "1",
        province_id: '',
        type: "1", 
        level: "0",
        order_type: '4',
        down_num: '50',
        subject_num: '2',
      };
      if (this.$refs["branch"]) {
        this.$refs["branch"].reset();
      }
      this.submitSearch();
    },

    // 筛选查询
    submitSearch() {
      this.getRankingList(this.searcheModel);
      this.getBriefingList(this.searcheModel);
      this.getTracesList(this.searcheModel);
      this.area_map_key += 1;
      this.area_table_key += 1;
      this.product_map_key += 1;
      this.customer_level_map_key += 1;
      this.goal_table_key += 1;
      this.customer_ratio_table_key += 1;
    },

    //销售排行榜
    getRankingList(params) {
      this.ranking_loading = true;
      const ranking_params = Object.assign({}, params, this.searcheModel);
      OrderCount.getRanking(ranking_params)
        .then((res) => {
          if (res.code == 0) {
            this.ranking_list = res.data;
          }
          this.ranking_loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.ranking_loading = false;
        });
    },

    //数据简报
    getBriefingList(params) {
      this.briefing_loading = true;
      OrderCount.getBriefing(params)
        .then((res) => {
          if (res.code == 0) {
            this.briefing_data = res.data;
          }
          this.briefing_loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.briefing_loading = false;
        });
    },

    //业务员跟进情况
    getTracesList(params) {
      this.traces_loading = true;
      OrderCount.getTraces(params)
        .then((res) => {
          if (res.code == 0) {
            this.traces_list = res.data;
          }
          this.traces_loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.traces_loading = false;
        });
    },

    //切换部门子组件
    changeBranch(value) {
      if (value && value.length > 0) {
        // 多选时 value 为路径数组，取每一项最后一级部门
        if (Array.isArray(value[0])) {
          this.searcheModel.branch_id = value.map(function (path) {
            return path[path.length - 1];
          });
        } else {
          this.searcheModel.branch_id = value[value.length - 1];
        }
      } else {
        this.searcheModel.branch_id = "";
      }
    },

    //设置申请时间：本周，本月，上周，上月
    setCreateAt(timeRange) {
        this.searcheModel.order_created_at = Config.getDataTimes(timeRange);
    },

    //切换统计指标
    handleRankingChange() {
      this.getRankingList(this.searcheModel);
      this.goal_table_key += 1;
    },

    //切换统计指标
    handleAreaClick() {
      this.area_map_key += 1;
      this.area_table_key += 1;
    },
    
    //切换统计指标
    handleProductClick() {
      this.product_map_key += 1;
    },

    chinaMapChange(val){
      this.searcheModel.province_id = val.id;
      this.area_table_key += 1;
    },

    // //切换统计指标
    // handleGoalClick() {
    //   this.goal_table_key += 1;
    // },
    ratioProgressChange(val){
      this.searcheModel.down_num = val.down_num;
      this.searcheModel.subject_num = val.subject_num;
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // 第一列不计算合计，显示自定义的文字内容
        if (index === 0) {
          sums.push('合计：');
          return;
        }
        // 初始化合计值为0
        let sum = 0;
        // 遍历数据，累加顶级行的值
        data.forEach(item => {
          // 累加当前项的值，注意转换为数字
          sum += Number(item[column.property]);
        });
        // 如果所有值都是数字，则显示合计结果，否则显示'-'
        if (!isNaN(sum)) {
          sums.push(Math.round(sum * 100) / 100); // 保留两位小数
        } else {
          sums.push('--');
        }
      });
      return sums
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/count/collect.vue